<template>
    <div class="w-100">
        <div class="kpi-neon-card pa-3 d-flex flex-column justify-space-between w-100">
            <!-- ENCABEZADO Y CHIP TOTAL -->
            <div class="d-flex justify-space-between align-center mb-2">
                <span class="category-title text-truncate font-weight-black text-grey-lighten-2">
                    Clientes
                </span>
                <v-chip size="x-small" color="cyan" variant="tonal" class="font-weight-black px-2" style="height: 18px; font-size: 0.60rem;">
                    TOTAL: {{ clientTotal }}
                </v-chip>
            </div>

            <!-- MATRIZ DE 4 ESTADOS HORIZONTALES -->
            <div class="d-flex align-center ga-2 w-100">
                <!-- EN LÍNEA -->
                <div class="status-neon-box ok-glow flex-grow-1 pa-2 text-center">
                    <v-icon color="#00E676" style="font-size: 13px;">mdi-check-circle-outline</v-icon>
                    <div class="status-value text-success mt-1">{{ clientData.ok }}</div>
                    <div class="status-label text-truncate" title="En Línea">En Línea</div>
                </div>

                <!-- ALERTA LEVE -->
                <div class="status-neon-box alert-glow flex-grow-1 pa-2 text-center">
                    <v-icon color="#FFEA00" style="font-size: 13px;">mdi-alert-circle-outline</v-icon>
                    <div class="status-value text-warning mt-1">{{ clientData.alert }}</div>
                    <div class="status-label text-truncate" title="Alerta Leve">Alerta</div>
                </div>

                <!-- ALARMA CRÍTICA -->
                <div class="status-neon-box alarm-glow flex-grow-1 pa-2 text-center">
                    <v-icon color="#FF3D00" style="font-size: 13px;">mdi-alert-octagon-outline</v-icon>
                    <div class="status-value text-error mt-1">{{ clientData.alarm }}</div>
                    <div class="status-label text-truncate" title="Alarma Crítica">Alarma</div>
                </div>

                <!-- SIN SERVICIO -->
                <div class="status-neon-box down-glow flex-grow-1 pa-2 text-center">
                    <v-icon color="#9E9E9E" style="font-size: 13px;">mdi-close-circle-outline</v-icon>
                    <div class="status-value text-grey-lighten-1 mt-1">{{ clientData.down }}</div>
                    <div class="status-label text-truncate" title="Sin Servicio">Sin Serv.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface StatusCounts {
    distri?: { ok: number; alarm: number; alert: number; down: number };
    acceso?: { ok: number; alarm: number; alert: number; down: number };
    client?: { ok: number; alarm: number; alert: number; down: number };
}

interface Props {
    statusCounts?: StatusCounts;
}

const props = withDefaults(defineProps<Props>(), {
    statusCounts: () => ({
        client: { ok: 0, alarm: 0, alert: 0, down: 0 }
    })
});

const clientData = computed(() => props.statusCounts?.client || { ok: 0, alarm: 0, alert: 0, down: 0 });

const clientTotal = computed(() => {
    const d = clientData.value;
    return (d.ok || 0) + (d.alarm || 0) + (d.alert || 0) + (d.down || 0);
});
</script>

<style scoped>
.kpi-neon-card {
    background: linear-gradient(135deg, rgba(13, 19, 31, 0.95) 0%, rgba(20, 29, 46, 0.85) 100%);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(8px);
}

.category-title {
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.status-neon-box {
    background-color: rgba(6, 9, 14, 0.6);
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    min-width: 0;
    transition: all 0.2s ease;
}

.status-value {
    font-size: 0.85rem;
    font-weight: 800;
    line-height: 1;
}

.status-label {
    font-size: 0.55rem;
    color: #94A3B8;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 3px;
}

.ok-glow { border-bottom: 2px solid #00E676; box-shadow: inset 0 -4px 8px rgba(0, 230, 118, 0.1); }
.alert-glow { border-bottom: 2px solid #FFEA00; box-shadow: inset 0 -4px 8px rgba(255, 234, 0, 0.1); }
.alarm-glow { border-bottom: 2px solid #FF3D00; box-shadow: inset 0 -4px 8px rgba(255, 61, 0, 0.1); }
.down-glow { border-bottom: 2px solid #9E9E9E; box-shadow: inset 0 -4px 8px rgba(158, 158, 158, 0.1); }
</style>